// Styles for use for lineage bars for filtered lineage items

import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from './LayoutComponents';
import { cssClass, Style } from './StyleFunctions';
import { Grey218, ListViewRowOuterHeight } from './VizPortalStyles';

const Spacing = TabStyles.Spacing;
const filteredBlue = 'rgb(52, 152, 219)';

export const lineageBarMaxWidth = 80;
export const lineageBarHeight = 4;

export const cellBarMaxWidth = '100%';
export const cellBarHeight = ListViewRowOuterHeight - (2 * Spacing.DefaultSpace);

export const animatedBarWidthStyle: Style = {
  transition: 'width 500ms 0ms',
};

export const baseBarStyle: Style = {
  borderRadius: 'inherit',
  maxWidth: '100%',
  width: '100%',
  position: 'relative'
};

export const filteredBarStyle: Style = {
  borderRadius: 'inherit',
  maxWidth: '100%',
  backgroundColor: Grey218,
  width: 0,
  position: 'absolute',
  left: 0,
  top: 0
};

export const baseBarClass = cssClass('baseBar', baseBarStyle);

export const filteredBarClass = cssClass('filteredBar', filteredBarStyle);

export const animatedBaseBarClass = cssClass('animatedBaseBar', baseBarStyle, animatedBarWidthStyle);

export const animatedFilteredBarClass = cssClass('animatedFilteredBarClass', filteredBarStyle, animatedBarWidthStyle);

export const BarLabel = divWithStyle('barLabel', {
  position: 'absolute',
  marginLeft: Spacing.DefaultSpace
});

export const cellAlignmentStyle: Style = {
  display: 'inline-block',
  verticalAlign: 'middle',
  width: `calc(100% - ${(Spacing.MediumSpace || 0) * 2}px)`,
  paddingLeft: Spacing.MediumSpace,
  paddingRight: Spacing.MediumSpace,
};

export const cellAlignmentClass = cssClass('cellAlignment', cellAlignmentStyle);

export const disabledCellAlignmentClass = cssClass('disabledCellAlignment', {
  ...cellAlignmentStyle,
  opacity: 0.6,
});

export const lineageBarColors = cssClass('lineageBarColors', {
  $nest: {
    [`.${animatedBaseBarClass}`]: {
      backgroundColor: Grey218,
    },
    [`.${animatedFilteredBarClass}`]: {
      backgroundColor: filteredBlue,
    }
  }
});

export const spacesBarColors = cssClass('spacesBarColors', {
  $nest: {
    [`.${filteredBarClass}`]: {
      backgroundColor: Grey218
    }
  }
});

export const connectToBarColors = cssClass('connectToBarColors', {
  $nest: {
    [`.${filteredBarClass}`]: {
      backgroundColor: filteredBlue
    }
  }
});

export type ColorPaletteName = 'spaces' | 'connectTo' | 'lineage';

export const colorPalettes: Record<ColorPaletteName, string> = {
  spaces: spacesBarColors,
  connectTo: connectToBarColors,
  lineage: lineageBarColors
};
